<template>
    <div class="">
        <iframe class="notification-iframe" src="/alert.html"  height="1000" style=""></iframe>
    </div>
</template>

<script>
export default {
    name:'NotificationIframe',
    data() {
        return {
        }
    }
}
</script>

<style lang="scss">
.notification-iframe{
	width:100%;
	border:none;
	padding:0 5px;
	height: calc(100vh - 50px);
	height: -webkit-calc(100vh - 50px);
	height: -moz-calc(100vh - 50px);
	margin-top: 45px;
}
</style>
